import React from "react";
import "./contact.css";
import Phone from "../../img/phone.png";
import Adress from "../../img/address.png";
import Email from "../../img/email.png";

function Contact() {
  return (
    <div className="c">
      <div className="c-bg"></div>
      <div className="c-wrapper">
        <div className="c-left">
          <h1 className="c-title">Tem alguma sugestão?</h1>
          <div className="c-info">
            <div className="c-info-item">
              <img className="c-icon" src={Phone} alt="fone" />
              (51) 99862-6689
            </div>
            <div className="c-info-item">
              <img className="c-icon" src={Email} alt="fone" />
              matheusreusch1@gmail.com
            </div>
            <div className="c-info-item">
              <img className="c-icon" src={Adress} alt="fone" />
              Rua Tomaz Flores, Porto Alegre
            </div>
          </div>
        </div>
        <div className="c-right">
          <h2 className="c-desc">Entre em contato comigo!</h2>
          <form>
            <input type="text" placeholder="Seu Nome" name="user_name" />
            <input type="text" placeholder="Assunto" name="user_subject" />
            <input type="text" placeholder="Seu Email" name="user_email" />
            <textarea rows="5" placeholder="Mensagem" name="message" />
            <button>Enviar</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
